import React from "react";

const dropdown = props => {
  return (
    <div>
      <select style={{ width: "300px", display: "inline-block"}} onChange={props.handleOnChange}>
      <option value="" selected disabled>{props.placeholder}</option>
        {props.options.map((option,index) => (
          <option key={option.nombre}value={index}>{option.nombre}</option>
        ))}
      </select>
    </div>
  );
};

export default dropdown;
